// Regras e profissionais da agenda, compartilhados entre as telas (ver AGENDA.md).
import { ref, computed } from 'vue';
import agendaAPI from 'dashboard/api/agenda';
import { timeToMinutes } from '../helpers/agendaTime';

const setting = ref({
  timezone: 'America/Sao_Paulo',
  min_notice_minutes: 120,
  horizon_days: 30,
  options_per_offer: 3,
});
const professionals = ref([]);
const isLoading = ref(false);
const hasLoaded = ref(false);

export function useAgendaData() {
  const activeProfessionals = computed(() =>
    professionals.value.filter(professional => professional.active)
  );

  const specialties = computed(() =>
    [...new Set(professionals.value.map(p => p.specialty))].sort()
  );

  const professionalById = id =>
    professionals.value.find(professional => professional.id === Number(id));

  // Períodos de atendimento do profissional num dia da semana, em minutos.
  const periodsFor = (professional, weekday) =>
    (professional?.working_periods || [])
      .filter(period => period.weekday === weekday)
      .map(period => ({
        start: timeToMinutes(period.start),
        end: timeToMinutes(period.end),
      }));

  const fetchAll = async () => {
    isLoading.value = true;
    try {
      const [settingResponse, professionalsResponse] = await Promise.all([
        agendaAPI.getSetting(),
        agendaAPI.getProfessionals(),
      ]);
      setting.value = settingResponse.data;
      professionals.value = professionalsResponse.data.payload;
      hasLoaded.value = true;
    } finally {
      isLoading.value = false;
    }
  };

  const replaceProfessional = professional => {
    const exists = professionals.value.some(
      item => item.id === professional.id
    );
    professionals.value = exists
      ? professionals.value.map(item =>
          item.id === professional.id ? professional : item
        )
      : [...professionals.value, professional];
  };

  const removeProfessional = id => {
    professionals.value = professionals.value.filter(item => item.id !== id);
  };

  return {
    setting,
    professionals,
    activeProfessionals,
    specialties,
    isLoading,
    hasLoaded,
    professionalById,
    periodsFor,
    fetchAll,
    replaceProfessional,
    removeProfessional,
  };
}
